import React from 'react'
import { LayoutSignatureDigital } from './layout/LayoutSignatureDigital'

export const SignatureDigital = () => {
    return (
        <LayoutSignatureDigital />
    )
}
